import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty-five',
  templateUrl: './home-thirty-five.component.html',
  styleUrls: ['./home-thirty-five.component.scss']
})
export class HomeThirtyFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
